<template>
  <div>
    <b-form-group
      label="Problème d'entretien "
      label-cols="4"
      :label-for="'work' + id + '_maintenanceProblem'"
    >
      <b-form-radio-group
        :numberWork="'work' + numberWork + '_maintenanceProblem'"
        buttons
        v-model="getForm['work' + numberWork + '_maintenanceProblem']"
        :options="options"
        size="lg"
        button-variant="outline-info"
        :name="'work' + numberWork + '_maintenanceProblem'"
      />
    </b-form-group>
    <b-form-group
      label="Commentaires "
      label-cols="4"
      :label-for="'work' + id + '_commentMaintenanceProblem'"
    >
      <b-form-textarea
        :numberWork="'work' + numberWork + '_commentMaintenanceProblem'"
        :name="'work' + numberWork + '_commentMaintenanceProblem'"
        class="form-control"
        v-model="getForm['work' + numberWork + '_commentMaintenanceProblem']"
        rows="3"
        max-rows="6"
        :maxlength="$MAX_2000"
      />
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SpecificWorkVe',
  props: {
    numberWork: { type: Number, required: true },
  },
  computed: {
    ...mapGetters(['getForm']),
  },
  data: () => ({
    id: '',
    options: [
      { text: 'Oui', value: 'oui' },
      { text: 'Non', value: 'non' },
      { text: 'Indéterminé', value: 'impossible' },
    ],
  }),
};
</script>
